'use strict';

const SELECTORS = {
    class: '.js-auto-select',
};

function init() {
    let items = document.querySelectorAll(SELECTORS.class);

    if (!items.length) {
        return false;
    }

    items.forEach(function (item) {
        item.addEventListener('change', function () {
            const elem = (typeof this.selectedIndex === 'undefined' ? window.event.srcElement : this);
            const value = elem.value || elem.options[elem.selectedIndex].value;

            const href = elem.getAttribute('data-base-href');
            const param = elem.getAttribute('name');

            location.href = href + '?' + param + '=' + value;
        });
    });
}

module.exports = {
    init
};



// WEBPACK FOOTER //
// ./modules/autoSelect.js